import styles from './ccf-consumer-card-header.module.scss';
import React from 'react';
import {
  CcfTypography,
  CcfEmailIcon,
  CcfSmsIcon,
  CcfWhatsAppIcon,
  CcfPhoneIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import makeStyles from '@mui/styles/makeStyles';
import { fomatToDateString, fomatToTimeString } from '@nice-ccf/core-sdk';

export interface CcfHeaderProps {
  children?: React.ReactElement[];
  HeaderWithTab?: React.ReactElement;
  HeaderWithBookmark?: React.ReactElement;
  tabList?: string[];
  headerText?: string;
  headerTextClassess?: string;
  LeftIcon?: React.ReactElement;
  showDragIcon?: boolean;
  RightIcon?: boolean;
  PopoverContent?: React.ReactElement;
  PopoverContentProps?: { dismissable: boolean };
  direction?: 'ltr' | 'rtl';
  isNewWindowIcon?: boolean;
}

const useStyles = makeStyles((theme) => ({
  customRootClass: {
    '&.MuiIconButton-root': { padding: '0px' },
  },
}));

/**
 *
 * @param headerText - Text to be displayed inside the Header Title
 * @param RightIcon - Icon to be displayed in the left side of the Header
 * @param PopoverContent - Content to be displayed inside the
 * @param headerTextClassess - Classes to be applied on the Header Text
 * @example <CCfHeader />
 * @returns CcfHeader Component
 */

/* eslint-disable-next-line */
export interface CcfConsumerCardHeaderProps {
  activeContact?: any;
  isMinViewVisible?: any;
}

/**
 * Component displays App header on landing screen
 * @param props -CcfAppHeaderProps
 * @returns app header component for landing screen
 * @example <CcfAppHeader/>
 */
export function CcfConsumerCardHeader({
  activeContact,
  isMinViewVisible,
  ...rest
}: CcfConsumerCardHeaderProps) {
  console.log('activeContact', activeContact?.lastVisited);
  const lastVisitedDate =
    fomatToDateString(new Date(activeContact?.lastVisited)) +
    ' ' +
    fomatToTimeString(new Date(activeContact?.lastVisited));
  const [translate] = useTranslator();
  return (
    <section
      id="agent_consumer_appSpace_headerContainer"
      className={`${styles.headerContainer}`}
      style={
        isMinViewVisible
          ? {
              width: '100%',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '10px',
            }
          : { width: 'auto', gap: '30px' }
      }
    >
      <div
        className={styles.consumerNameHeader}
        id="agent_consumer_appSpace_consumerDetails"
      >
        <div className={`${styles.consumerNameDiv}`}>
          <CcfTypography className={`${styles.headerLabel}`}>
            {[
              activeContact?.customer?.firstName,
              activeContact?.customer?.middleName,
              activeContact?.customer?.lastName,
            ]
              .filter(Boolean)
              .join(' ')}
          </CcfTypography>
          <CcfTypography style={{ fontSize: '12px', color: '#333333' }}>
            (#{activeContact?.customer.phoneNo})
          </CcfTypography>
        </div>
        <div>
          <CcfTypography style={{ color: '#727272', fontSize: '12px' }}>
            {translate('lastUpdated')} {lastVisitedDate}
          </CcfTypography>
        </div>
      </div>
      <div
        style={
          isMinViewVisible
            ? { justifyContent: 'center', width: '100%' }
            : { width: 'auto' }
        }
        className={styles.iconDiv}
        id="agent_consumer_appSpace_headerIconDiv"
      >
        <CcfPhoneIcon />
        <CcfEmailIcon className={styles.emailIcon} />
        <CcfSmsIcon fillColor={'#0d3970'} />
        <CcfWhatsAppIcon fillColor={'#0d3970'} />
      </div>
    </section>
  );
}

export default CcfConsumerCardHeader;
